<template>
<div class="chapter">
<div class="inner_page">
<div class="center">
<p class="structure" xml:lang="en-GB"><span class="bold"><span><img alt="17873.png" class="frame" src="OEBPS/image/17873.png"/></span> </span></p>
<div class="calibre1" id="calibre_pb_0"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HappyHealthyYou_split_000.vue?042ab638